import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'app-navigation-stepper',
    templateUrl: './stepper.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    providers: [
        { provide: CdkStepper, useExisting: NavigationStepperComponent },
    ],
    imports: [CommonModule, NgTemplateOutlet, CdkStepperModule],
})
export class NavigationStepperComponent extends CdkStepper {
    @Input()
    activeClass = 'active';
}
